import LabeledContainer from './LabeledContainer';
export default LabeledContainer;